import React from 'react';
import { PlusIcon } from './Icons';
import './PopularProducts.css';

const PopularProducts = () => {
  const products = [
    {
      name: 'Avocado',
      price: '$2.5 / ea',
      bgClass: 'avocado-bg'
    },
    {
      name: 'Wholemeal Bread',
      price: '$2.50 / ea',
      bgClass: 'bread-bg'
    },
    {
      name: 'Bananas',
      price: '$3.55 / kg',
      bgClass: 'banana-bg'
    }

  ];

  return (
    <section className="popular-section">
      <h3>Popular</h3>
      <div className="products-scroll">
        {products.map((product, index) => (
          <div key={index} className="product-card">
            <div className={`product-image ${product.bgClass}`}>
              {/* 产品图片背景 */}
            </div>
            <div className="product-info">
              <h4 className="product-title">{product.name}</h4>
              <div className="product-footer">
                <span className="product-price">{product.price}</span>
                <button className="add-button">
                  <PlusIcon />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PopularProducts; 